import { cellRenders, filterComponents, filterMethods } from "../utils/filtersAndCells";
import getLookups from "../Config/lookups.js";

const { listValueCell, binaryCell } = cellRenders();
const { ListFilter, BinaryFilter } = filterComponents();
const { exactMatchFilterMethod, binaryFilterMethod } = filterMethods();
const { providers, countries } = getLookups();

const headerStyle = {
  textAlign: "center",
  fontWeight: "bold",
  color: "#333333",
};

const cellStyle = {
  textAlign: "center",
};

/**
 * Returns the column configuration for the Providers table.
 * @param {boolean} hasAdmin - Flag indicating whether to include the actions column.
 * @returns {Array} Array of column configuration objects.
 */
export default function getProviderColumns(hasAdmin) {
  const columns = [
    { accessor: "id", show: false },
    {
      Header: "Name",
      accessor: "name",
      style: cellStyle,
      headerStyle,
    },
    {
      Header: "State/Province",
      accessor: "state",
      style: cellStyle,
      headerStyle,
    },
    {
      Header: "City",
      accessor: "city",
      style: cellStyle,
      headerStyle,
    },
    {
      Header: "Phone",
      accessor: "phone",
      style: cellStyle,
      headerStyle,
    },
    {
      Header: "Has SMS Phone",
      accessor: "hasSmsPhone",
      style: cellStyle,
      headerStyle,
      Cell: binaryCell,
      filterMethod: binaryFilterMethod,
      Filter: BinaryFilter,
    },
    {
      Header: "SMS Phone",
      accessor: "smsPhone",
      style: cellStyle,
      headerStyle,
    },
    {
      Header: "Provider Type",
      accessor: "providerType",
      style: cellStyle,
      headerStyle,
      Cell: listValueCell(providers),
      filterMethod: exactMatchFilterMethod,
      Filter: ListFilter(providers),
    },
    {
      Header: "Address",
      accessor: "address",
      style: cellStyle,
      headerStyle,
    },
    {
      Header: "Country",
      accessor: "country",
      style: cellStyle,
      headerStyle,
      Cell: listValueCell(countries),
      filterMethod: exactMatchFilterMethod,
      Filter: ListFilter(countries),
    },
    {
      Header: "Email",
      accessor: "email",
      style: cellStyle,
      headerStyle,
    },
    {
      Header: "Website",
      accessor: "website",
      style: cellStyle,
      headerStyle,
    },
    {
      Header: "Notes",
      accessor: "notes",
      style: cellStyle,
      headerStyle,
    },
    {
      Header: "Telehealth",
      accessor: "telehealth",
      style: cellStyle,
      headerStyle,
    },
  ];

  if (hasAdmin) {
    columns.push({
      Header: "Actions",
      accessor: "actions",
      sortable: false,
      filterable: false,
      headerStyle: cellStyle,
    });
  }

  return columns;
}
